import Typography from '@components/std-components/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const InactiveIcon: React.FC = (): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Typography variant='body1' color='error'>
      {t('common.label.inactive', 'Inactive').toLocaleUpperCase()}
    </Typography>
  )
}
